/**
 * Minimal globals required by the imported storefront components
 * (search-form.js, predictive-search.js, details-modal.js) when they run on
 * theme pages that don't load the demo's script.js.
 */
window.debounce =
  window.debounce ||
  function (fn, wait) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  };

window.trapFocus =
  window.trapFocus ||
  function (container, elementToFocus) {
    const target = elementToFocus || container;
    if (target && typeof target.focus === 'function') target.focus();
  };

window.removeTrapFocus =
  window.removeTrapFocus ||
  function (elementToFocus) {
    if (elementToFocus && typeof elementToFocus.focus === 'function') elementToFocus.focus();
  };

window.onKeyUpEscape = window.onKeyUpEscape || function () {};
